import React, { useEffect } from "react";
import Lenis from "lenis";

export default function SmoothScroll({ enabled = true, children }) {
    useEffect(() => {
        if (!enabled) return undefined;
        const lenis = new Lenis({
            duration: 1.35,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            smoothWheel: true,
            wheelMultiplier: 1,
        });
        let rafId;
        function raf(time) {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        }
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
        };
    }, [enabled]);
    return <>{children}</>;
}
